// Single-sourced in the shared react-free core (`@repeatmd/camera-core`). Kept
// as a local re-export so existing `@/features/camera/captureFrame` imports
// (and their test mocks) keep working. See docs/FRONTEND_TURBOREPO.md.
export { captureFrame, captureFrameToFile, type CaptureFrameOptions } from "@repeatmd/camera-core";
